import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    ...shorthands.overflow("hidden"),
    whiteSpace: "nowrap",
    clip: "rect(0,0,0,0)",
  },
  switch: {
    display: "inline-flex",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    ...shorthands.gap(designTokens.spacing[2]),
  },
  innerContainer: {
    display: "flex",
    flexWrap: "wrap",
    ...shorthands.gap(designTokens.spacing[2]),
    alignItems: "center",
  },
  botButton: {
    display: "inline-flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
    ...shorthands.padding(designTokens.spacing[1], designTokens.spacing[2]),
    backgroundColor: designTokens.accent[50],
    color: designTokens.accent[700],
    ...shorthands.border("1px", "solid", designTokens.accent[500]),
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    minHeight: "auto",
    ...shorthands.overflow("hidden"),
    whiteSpace: "nowrap",
    transition: designTokens.transition.fast,
    ":hover": {
      backgroundColor: designTokens.accent[100],
      color: designTokens.accent[700],
    },
    ":active": {
      backgroundColor: designTokens.accent[200],
      color: designTokens.accent[700],
    },
  },
  nhToggle: {
    ...shorthands.padding(designTokens.spacing[1], designTokens.spacing[2]),
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[700],
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.normal,
    height: "30px",
    minHeight: "auto",
    boxSizing: "border-box",
    transition: designTokens.transition.fast,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
  },
  nhToggleCompact: {
    ...shorthands.padding(designTokens.spacing[1], designTokens.spacing[2]),
    borderRadius: designTokens.borderRadius.lg,
    "--fui-Button__icon-spacing": "0px",
  },
  nhTogglePressed: {
    backgroundColor: designTokens.accent[50],
    color: designTokens.accent[700],
    ...shorthands.borderColor(designTokens.accent[500]),
    ":hover": {
      backgroundColor: designTokens.accent[100],
      color: designTokens.accent[700],
    },
    ":active": {
      backgroundColor: designTokens.accent[200],
      color: designTokens.accent[700],
    },
  },
  menuPopover: {
    maxWidth: "none",
    minWidth: "max-content",
    boxShadow: designTokens.shadow.lg,
    borderRadius: designTokens.borderRadius.lg,
  },
  menuItem: {
    whiteSpace: "nowrap",
    width: "100%",
    paddingTop: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
    paddingLeft: designTokens.spacing[1],
    paddingRight: designTokens.spacing[1],
  },
  menuItemSelected: {
    width: "100%",
    whiteSpace: "nowrap",
    backgroundColor: designTokens.accent[50],
    borderRadius: designTokens.borderRadius.md,
    fontWeight: designTokens.fontWeight.medium,
    outlineWidth: "1px",
    outlineStyle: "solid",
    outlineColor: designTokens.accent[500],
    color: designTokens.accent[700],
    ":hover": {
      backgroundColor: designTokens.accent[50],
      color: designTokens.accent[700],
    },
    ":active": {
      backgroundColor: designTokens.accent[200],
      color: designTokens.accent[700],
    },
  },
  compactContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    ...shorthands.gap(designTokens.spacing[1]),
  },
  compactSpacer: {
    flex: 1,
  },
  compactButton: {
    display: "inline-flex",
    alignItems: "center",
    ...shorthands.gap(designTokens.spacing[1]),
    ...shorthands.padding(designTokens.spacing[1], designTokens.spacing[2]),
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[700],
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    borderRadius: designTokens.borderRadius.lg,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    height: "30px",
    minHeight: "auto",
    boxSizing: "border-box",
    cursor: "pointer",
    transition: designTokens.transition.fast,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
  },
  compactChevron: {
    fontSize: "10px",
    color: designTokens.neutral[400],
  },
  dotClaude: {
    width: "8px",
    height: "8px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.semantic.success,
    flexShrink: 0,
  },
  dotOpenai: {
    width: "8px",
    height: "8px",
    borderRadius: designTokens.borderRadius.full,
    backgroundColor: designTokens.semantic.info,
    flexShrink: 0,
  },
});
